import {GoogleMap, useLoadScript, Marker, DirectionsRenderer,Circle} from "@react-google-maps/api";
import React, {useContext, useEffect, useMemo, useRef, useState} from "react";
import axios from "axios";
import usePlacesAutocomplete, {getGeocode,getLatLng,} from "use-places-autocomplete";
import {Typeahead} from "react-bootstrap-typeahead";
import LangContext from "../../../../../context/LangContext";
import {Form} from "react-bootstrap";
import {urlConfig} from "../../../../../config/urlConfig";

export const Mapa = ({surveyorList,setSurveyorList,
                         claimForm,setClaimForm,
                         pag,
                         distance,setDistance,
                         oneSurveyor, setOneSurveyor,
                         setDireccion, direccion,setAddressForm,
                         onlySurveyor, range, setRange,
                         mapCode,setMapCode,addressForm}) => {
    const [ libraries ] = useState(['places']);

    const {isLoaded} = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_APIKEY_GOOGLE,
        libraries
    });

    if (!isLoaded) return <div>Loading...</div>;
    // console.log(addressForm)
    return(
        <>
            <Map direccion={direccion} setDireccion={setDireccion}
                 setAddressForm={setAddressForm}
                 pag={pag}
                 distance={distance}
                 setDistance={setDistance}
                 isLoaded={isLoaded}
                 oneSurveyor={oneSurveyor} setOneSurveyor={setOneSurveyor}
                 claimForm={claimForm} setClaimForm={setClaimForm}
                 surveyorList={surveyorList} setSurveyorList={setSurveyorList}
                 range={range} setRange={setRange}
                 onlySurveyor={onlySurveyor}
                 setMapCode={setMapCode}
                 mapCode={mapCode}
                 addressForm={addressForm}
            />
        </>
    )
}

const Map =(props)=>{
    const [directionsResponse, setDirectionsResponse] = useState(null);
    const [address, setAddress] = useState({lat:0,lng:0});
    const [inicio, setInicio] = useState( {lat:0,lng:0})
    const [markerAnim, setMarkerAnim] = useState(2);
    const {traduccion} = useContext(LangContext);
    const [zoomMap, setZoomMap] = useState(10);
    useEffect(() => {
        if(props.addressForm?.lat===0 && props.addressForm?.lng===0){
            setAddress({lat:51.50742726621612,lng:-0.08603244575278834})
            setInicio({lat:51.50742726621612,lng:-0.08603244575278834})
        }else if (props.addressForm){
            setAddress(props.addressForm)
            setInicio(props.addressForm)
        }
    }, []);

    useEffect(() => {
        // if (props.setAddressForm){
        //     props.setAddressForm(address)
        //     console.log(address)
        // }
    }, [address]);

    useEffect(() => {
        // console.log(address)
        if (props.pag===1 && props?.claimForm) {
            const datos = {
                longitude:address.lng,
                latitude:address.lat
            }
            //actualizo el estado de claimForm
            props.setClaimForm({...props.claimForm, ...datos})

            //actualizar el sessionStorage
            sessionStorage.setItem('claimForm', JSON.stringify({...props.claimForm, ...datos}))
            const token = localStorage.getItem("token");
            axios.post(`${urlConfig.allUrl}:9002/api/v1/inspector/location`,datos,{
                headers: {
                    Authorization: token?.toString().replace("Bearer ", "")
                }
            })
                .then((res) =>{
                    //console.log(res.data)
                    props.setSurveyorList(res.data)
                }).catch((error)=>{
                console.error(error);
            })
        }

    }, [address]);

    const calculateRoute = () => {
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: { lat: props.oneSurveyor.latitude, lng: props.oneSurveyor.longitude },
                destination: { lat: props.claimForm.latitude, lng: props.claimForm.longitude },
                travelMode: window.google.maps.TravelMode.DRIVING,
                drivingOptions: {
                    departureTime: new Date(Date.now()),
                    trafficModel: 'pessimistic'
                }
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    props.setOneSurveyor({...props.oneSurveyor,
                        distance_m:result.routes[0].legs[0].distance.value,
                        duration_m:result.routes[0].legs[0].duration_in_traffic.value})
                    setDirectionsResponse(result);
                    // console.log(result)
                    props.setDistance(result.routes[0].legs[0])
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            }
        );
    }

    useEffect(() => {
        if(props.setClaimForm){
            props.setClaimForm({
                ...props.claimForm,
                distance:props.distance?.distance.value})
            //update sessionstorage claim
            sessionStorage.setItem("claim", JSON.stringify(props.claimForm));
        }
    }, [props.distance]);

    useEffect(() => {
        if (props.pag===2) {
            calculateRoute();
        }
    }, [props.pag]);


    const startAnim =()=>{
        setMarkerAnim(1)
    }
    const endAnim  =(e)=>{
        setMarkerAnim(2);
        nuevoLocation(e)
    }
    const clickAnim  = async ()=>{
        await setMarkerAnim(4);
        setMarkerAnim(2)
    }

    function showPosition(position) {

        let addObj = {lat:position.coords.latitude,lng:position.coords.longitude}

        setAddress(addObj);
        if (props.setAddressForm){
            props.setAddressForm(addObj)
        }
        setInicio(addObj);
    }
    function changePosition(position) {
        // console.log(position)
        if (props.setAddressForm){
            props.setAddressForm(position)
        }
        setAddress(position);
        setInicio(position);
    }

    useEffect(() => {
        getLocation();
    }, []);


    function getLocation() {
        // console.log(props.addressForm)
        // console.log(address)
        // console.log(inicio)
        if ((props.pag===1 && !props.addressForm)||(window.location.href.includes("mantenedor_inspectores")&& (props.addressForm?.lat===0 && props.addressForm?.lng===0))) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(showPosition)
            } else {
                console.info("Geolocation is not supported by this browser/user.")
            }
        }

    }

    let style = {height:"600px",maxHeight:"50vh",width:"100%"}
    //const [centro, setCentro] = useState({lat:44,lng:-80});
    // const center = (useMemo(() => (address),[]))
    // const title = useMemo(() => {
    //     return address
    // }, [address])


    const handleSelectReverse = async (address) => {
        // console.log(address)
        axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng="+address.lat+","+address.lng+"&key="+process.env.REACT_APP_APIKEY_GOOGLE)
            .then((res) =>{
                // console.log(res)

                let codePaisArr;
                if (res.data.results[res.data.results.length-1].address_components[0].types.findIndex((e)=>e==="country") !== -1){
                    codePaisArr = res.data.results[res.data.results.length-1].address_components[0].short_name;
                }else{
                    codePaisArr = res.data.results[res.data.results.length-2].address_components[0].short_name;
                }
                if(props.setMapCode){
                    props.setMapCode(codePaisArr)
                }
                // props.setMapCode(codePaisArr)
                // console.log(res.data.results[0].formatted_address)
                // console.log(props)
                if(props.setDireccion){
                    props.setDireccion(res.data.results[0].formatted_address)
                }
                // if (props.pag===1) {
                //     props.setAddressForm(res.data.results[0].formatted_address)
                // }
            }).catch((error)=>{
            console.error(error);
        })
    };


    const nuevoLocation =(e)=>{
        // console.log(e)
        let addObj = {lat:e.latLng.lat(),lng:e.latLng.lng()}
        handleSelectReverse(addObj)
        setAddress(addObj)
        if (props.setAddressForm){
            props.setAddressForm(addObj)
        }
        clickAnim()

    }
    useEffect(() => {
        switch (true) {
            case props.range>0&&props.range<=3000:
                setZoomMap(13)
                break;
            case props.range>3000&&props.range<=30000:
                setZoomMap(10)
                break;
            case props.range>30000&&props.range<=60000:
                setZoomMap(9)
                break;
            case props.range>60000&&props.range<=100000:
                setZoomMap(8)
                break;
            case props.range>100000&&props.range<=230000:
                setZoomMap(7)
                break;
            case props.range>230000&&props.range<=400000:
                setZoomMap(6)
                break;
            case props.range>400000&&props.range<=900000:
                setZoomMap(5)
                break;
            case props.range>900000&&props.range<=1600000:
                setZoomMap(4)
                break;
            case props.range >1600000:
                setZoomMap(1)
                break;
            default:
                setZoomMap(10)
        }

    }, [props.range]);
    // useEffect(() => {
    //
    //     console.log(zoomMap)
    //
    // }, [zoomMap]);
    // console.log(props)
    // console.log(zoomMap)
    return(
        <>
            {props.pag === 1 &&
                <PlacesAutocomplete changePosition={changePosition} setMapCode={props?.setMapCode} setDireccion={props.setDireccion} setZoomMap={setZoomMap} direccion={props.direccion} onlySurveyor={props.onlySurveyor} traduccion={traduccion}  />
            }
            {props.onlySurveyor &&
                <div style={{marginBottom:20}}>
                    <div>Operation Range</div>
                    <Form.Control
                        type="text"
                        placeholder="Enter range"
                        value={props.range/1000}
                        onChange={(e)=>{props.setRange(e.target.value>0? e.target.value*1000:0)}}
                    />
                </div>
            }

            <GoogleMap
                zoom={zoomMap}
                mapContainerStyle={style}
                center={inicio}
                onClick={(e)=> nuevoLocation(e)}
            >
                {props.pag === 1 &&
                    <>
                        <Marker
                            clickable={true}
                            position={address}
                            animation={markerAnim}
                            draggable={true}
                            onDragEnd={endAnim}
                            title={props.direccion}
                            onDragStart={startAnim}

                        />
                        if (props.onlySurveyor){
                        <Circle
                            center={address}
                            radius={props.range}
                            options={{
                                fillColor: "#003cff",
                                fillOpacity: 0.2,
                                strokeColor: "#003cff",
                                strokeOpacity: 1,
                                strokeWeight: 2,
                            }}
                        />
                    }

                    </>
                }
                {directionsResponse && (
                    <DirectionsRenderer
                        options={{ suppressMarkers: true }}
                        directions={directionsResponse}
                    />
                )}

            </GoogleMap>


        </>
    )
}

const PlacesAutocomplete = ({ changePosition,setDireccion,direccion,onlySurveyor,traduccion,setMapCode,setZoomMap}) => {

    const {
        ready,
        value,
        setValue,
        suggestions: { status, data },
        clearSuggestions,

    } = usePlacesAutocomplete();

    // const handleSelect = async (address) => {
    //     console.log(address)
    //     setValue(address, false);
    //     clearSuggestions();
    //
    //     const results = await getGeocode({ address });
    //     const { lat, lng } = await getLatLng(results[0]);
    //     changePosition({ lat, lng });
    // };
    const refContainer = useRef(null);

    useEffect(() => {
        // refContainer.current=direccion;
        if (refContainer.current !== null) {
            refContainer.current.innerHTML = direccion;
        }
        // console.log(direccion)
    }, [direccion]);

    const handleSelect2 = async (address) => {
        if (address[0]) {
            address=address[0].description
            setValue(address, false);
            clearSuggestions();
            if(setDireccion){
                setDireccion(address);
                setZoomMap(13)

            }

            const results = await getGeocode({address});
            // console.log(results)

            let codePaisArr;
            if (results[0].address_components[results[0].address_components.length-1].types.findIndex((e)=>e==="country")  !==-1){
                codePaisArr = results[0].address_components[results[0].address_components.length-1].short_name
            }else{
                codePaisArr = results[0].address_components[results[0].address_components.length-2].short_name
            }
            if(setMapCode){
                setMapCode(codePaisArr)
            }

            const {lat, lng} = await getLatLng(results[0]);
            changePosition({lat, lng});
        }
    };


    // console.log(direccion)
    return (

        <>
            {/*</div>*/}
            {/*    {*/}
            {/*        onlySurveyor &&*/}
            {/*        <>*/}
            {/*            <div>Actual Direction:</div>*/}
            {/*            <div ref={refContainer} style={{marginBottom:10}}></div>*/}
            {/*        </>*/}
            {/*    }*/}
            <div>{traduccion.inspector?.buscarDireccion}</div>
            <Typeahead
                style={{marginBottom:'1rem'}}
                id="basic-typeahead"
                labelKey={option => `${option.description}`}
                onChange={e=>handleSelect2(e)}
                onInputChange={e=>setValue(e)}
                placeholder={direccion?? "Search an address"}
                options={data.map(({ place_id, description }) => ({place_id:place_id, description:description}))}
            />

        </>

    );
};